import axios from "axios";

export const state = {
    requirementallocations: [],
};

export const getters = {
    requirementallocations: state => state.requirementallocations,
};

export const mutations = {
    setRequirementAllocations(state, newValue) {
        state.requirementallocations = newValue
    },
};

export const actions = {
    fetchRequirementAllocations({ commit }) {
        axios.get('/requirementallocations').then(res => {
            commit('setRequirementAllocations', res.data.requirementallocations); 
        })
    },
};
